import { Check, CheckCircle } from "@mui/icons-material";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import dayjs from "dayjs";
import React, { Fragment, memo, useMemo } from "react";
import { TRANSPORTATION_TYPE } from "src/constant";
import { useFormContext, useWatch } from "react-hook-form";
import FormControlInput from "./FormControlInput";

const PICKUP_TYPE_OPTIONS = [
  {
    type: TRANSPORTATION_TYPE.PICKUP,
    title: "Lấy hàng",
    lines: ["ĐVVC sẽ đến địa chỉ của bạn để lấy hàng"],
  },
  {
    type: TRANSPORTATION_TYPE.SELFDELIVERY,
    title: "Gửi hàng tại bưu cục",
    lines: ["Bạn có thể gửi ở bất kì bưu cục: ", "Bưu cục gần nhất"],
  },
];

function PickUpWithLimit({ item }) {
  const { setValue, control } = useFormContext();
  const pickupDate = useWatch({ control, name: "pickupDate" });
  const pickUpType = useWatch({ control, name: "pickUpType" });

  const datePickUp = useMemo(() => {
    const base = item?.createdAt ? new Date(item.createdAt) : new Date();
    return Array.from({ length: 3 }, (_, index) => {
      const d = new Date(base);
      d.setDate(d.getDate() + index);
      return d;
    });
  }, [item?.createdAt]);

  return (
    <Fragment>
      <Grid
        item
        xs={12}
        mb="24px"
      >
        <Typography
          fontWeight="bold"
          mb="12px"
        >
          Chọn ngày lấy hàng
        </Typography>
        <Box
          display="flex"
          gap="12px"
        >
          {datePickUp.map((v) => {
            const dayKey = v.toISOString().slice(0, 10);
            const selected = pickupDate?.includes(dayKey);
            return (
              <Button
                endIcon={selected && <CheckCircle color="var(--success-txt)" />}
                onClick={() => setValue("pickupDate", v.toISOString())}
                sx={{
                  borderRadius: "100px",
                  color: selected ? "var(--success-txt) !important" : "var(--black)",
                  borderColor: selected ? "var(--success-txt) !important" : "var(--black)",
                }}
                variant="outlined"
                key={dayKey}
              >
                {dayjs(v).format("dddd") + " - " + dayjs(v).format("DD-MM-YYYY")}
              </Button>
            );
          })}
        </Box>
      </Grid>
      <Grid
        xs={12}
        item
        display="flex"
        gap="12px"
      >
        {PICKUP_TYPE_OPTIONS.map(({ type, title, lines }) => {
          const selected = pickUpType === type;
          const textColor = selected ? "var(--success-txt)" : "var(--black)";
          return (
            <Box
              key={type}
              onClick={() => setValue("pickUpType", type)}
              sx={{
                background: selected ? "var(--success)" : "var(--light-grey)",
                opacity: 0.8,
                borderRadius: "6px",
                flex: 1,
                p: "12px",
                cursor: "pointer",
              }}
            >
              {selected && (
                <Check
                  sx={{
                    fontSize: "18px",
                    display: "flex",
                    m: "0 0 -18px auto",
                    color: "var(--success-txt)",
                  }}
                />
              )}
              <Typography
                fontWeight="bold"
                sx={{ color: textColor }}
              >
                {title}
              </Typography>
              {lines.map((line) => (
                <Typography
                  key={line}
                  variant="body2"
                  sx={{ color: textColor }}
                >
                  {line}
                </Typography>
              ))}
            </Box>
          );
        })}
      </Grid>
      <Grid mt="24px">
        <FormControlInput
          name="note"
          label="Ghi chú"
          fullWidth
          multiline
          rows={6}
        />
      </Grid>
    </Fragment>
  );
}

export default memo(PickUpWithLimit);
